export default __webpack_public_path__ + "static/media/Avatar4.4178339d.svg";